<script setup lang="ts">
const { cart } = useCart();
const description = cart.value.shipping.packages.length ? "Choisissez de quelle façon vous souhaitez obtenir votre commande." : "Votre commande ne nécessite pas de livraison!";
</script>

<template>
  <UiSidebarCard title="Expédition / Cueillette" :description="description">
    <template #picto>
      <SvgPictoShipping />
    </template>
    <CartChooseShippingMethod />
    <div class="text-xl font-medium">
      Adresse de livraison
    </div>
    <UpdateCustomerDetailsForm prefix="shipping" />
  </UiSidebarCard>
</template>
